<template>
  <div v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item"><a href="/#/works">Портфолио</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ category.name}}</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-white">Портфолио</h4>
              <p class="text-white">Тут собраны все работы,которые были выполнены мной</p>
              

            </div>
          </div>

          <div class="row col-md-12 mt-3" v-if="works.length>0">
            <router-link v-for="work in works" :key="work.last_id"
                         v-if="works.length>0"
                         :to="{name: 'workpage', params: { username: work.user.username,work_id:work.last_id }}">
              <sui-card class="col-md-3 m-2">
                <a href="#">

                  <sui-image :src="work.image"/>
                </a>
                <sui-card-content>
                  <sui-card-header><a>{{ work.name }}</a></sui-card-header>
                  <sui-card-meta>
                    <a>{{ work.date_start }}-{{ work.date_end }}</a>
                    <a>{{ work.category.name }}</a>
                  </sui-card-meta>
                </sui-card-content>
              </sui-card>
            </router-link>


          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {},
  data() {
    return {
     "category":null,
     "works":[],
     "is_load":false,
    }
  },
  mounted() {
  var category_id=this.$route.params.category_id;
  var app=this;
  Api.loadAboutWorks_in_cat(category_id,function(data){
    console.log('categorys portfolio');
    console.log(data);
    app.category=data.category;
    app.works=data.works;
    app.is_load=true;
  })
  },
  methods: {





  }
};
</script>
